import moment from 'moment';
import { appConfigManager } from './appConfigs';
import { range } from 'lodash';
import { PaymentFrequencyType } from '@nxsys/types/models/Common';
import { TaxYearOption } from '@nxsys/components/TaxYearSelect/types';

const isLeapYear = (year: number) =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

export const taxPeriodConfig = [
  {
    week: 1,
    month: 4,
    minDay: 6,
    maxDay: 12,
  },
  {
    week: 2,
    month: 4,
    minDay: 13,
    maxDay: 19,
  },
  {
    week: 3,
    month: 4,
    minDay: 20,
    maxDay: 26,
  },
  {
    week: 4,
    month: 4,
    minDay: 27,
    maxDay: 30,
  },
  {
    week: 4,
    month: 5,
    minDay: 1,
    maxDay: 3,
  },
  {
    week: 5,
    month: 5,
    minDay: 4,
    maxDay: 5,
  },
  {
    week: 5,
    month: 5,
    minDay: 6,
    maxDay: 10,
  },
  {
    week: 6,
    month: 5,
    minDay: 11,
    maxDay: 17,
  },
  {
    week: 7,
    month: 5,
    minDay: 18,
    maxDay: 24,
  },
  {
    week: 8,
    month: 5,
    minDay: 25,
    maxDay: 31,
  },
  {
    week: 9,
    month: 6,
    minDay: 1,
    maxDay: 7,
  },
  {
    week: 10,
    month: 6,
    minDay: 8,
    maxDay: 14,
  },
  {
    week: 11,
    month: 6,
    minDay: 15,
    maxDay: 21,
  },
  {
    week: 12,
    month: 6,
    minDay: 22,
    maxDay: 28,
  },
  {
    week: 13,
    month: 6,
    minDay: 29,
    maxDay: 30,
  },
  {
    week: 13,
    month: 7,
    minDay: 1,
    maxDay: 5,
  },
  {
    week: 14,
    month: 7,
    minDay: 6,
    maxDay: 12,
  },
  {
    week: 15,
    month: 7,
    minDay: 13,
    maxDay: 19,
  },
  {
    week: 16,
    month: 7,
    minDay: 20,
    maxDay: 26,
  },
  {
    week: 17,
    month: 7,
    minDay: 27,
    maxDay: 31,
  },
  {
    week: 17,
    month: 8,
    minDay: 1,
    maxDay: 2,
  },
  {
    week: 18,
    month: 8,
    minDay: 3,
    maxDay: 9,
  },
  {
    week: 19,
    month: 8,
    minDay: 10,
    maxDay: 16,
  },
  {
    week: 20,
    month: 8,
    minDay: 17,
    maxDay: 23,
  },
  {
    week: 21,
    month: 8,
    minDay: 24,
    maxDay: 30,
  },
  {
    week: 22,
    month: 8,
    minDay: 31,
    maxDay: 31,
  },
  {
    week: 22,
    month: 9,
    minDay: 1,
    maxDay: 6,
  },
  {
    week: 23,
    month: 9,
    minDay: 7,
    maxDay: 13,
  },
  {
    week: 24,
    month: 9,
    minDay: 14,
    maxDay: 20,
  },
  {
    week: 25,
    month: 9,
    minDay: 21,
    maxDay: 27,
  },
  {
    week: 26,
    month: 9,
    minDay: 28,
    maxDay: 30,
  },
  {
    week: 26,
    month: 10,
    minDay: 1,
    maxDay: 4,
  },
  {
    week: 27,
    month: 10,
    minDay: 5,
    maxDay: 11,
  },
  {
    week: 28,
    month: 10,
    minDay: 12,
    maxDay: 18,
  },
  {
    week: 29,
    month: 10,
    minDay: 19,
    maxDay: 25,
  },
  {
    week: 30,
    month: 10,
    minDay: 26,
    maxDay: 31,
  },
  {
    week: 30,
    month: 11,
    minDay: 1,
    maxDay: 1,
  },
  {
    week: 31,
    month: 11,
    minDay: 2,
    maxDay: 8,
  },
  {
    week: 32,
    month: 11,
    minDay: 9,
    maxDay: 15,
  },
  {
    week: 33,
    month: 11,
    minDay: 16,
    maxDay: 22,
  },
  {
    week: 34,
    month: 11,
    minDay: 23,
    maxDay: 29,
  },
  {
    week: 35,
    month: 11,
    minDay: 30,
    maxDay: 30,
  },
  {
    week: 35,
    month: 12,
    minDay: 1,
    maxDay: 6,
  },
  {
    week: 36,
    month: 12,
    minDay: 7,
    maxDay: 13,
  },
  {
    week: 37,
    month: 12,
    minDay: 14,
    maxDay: 20,
  },
  {
    week: 38,
    month: 12,
    minDay: 21,
    maxDay: 27,
  },
  {
    week: 39,
    month: 12,
    minDay: 28,
    maxDay: 31,
  },
  {
    week: 39,
    month: 1,
    minDay: 1,
    maxDay: 3,
  },
  {
    week: 40,
    month: 1,
    minDay: 4,
    maxDay: 10,
  },
  {
    week: 41,
    month: 1,
    minDay: 11,
    maxDay: 17,
  },
  {
    week: 42,
    month: 1,
    minDay: 18,
    maxDay: 24,
  },
  {
    week: 43,
    month: 1,
    minDay: 25,
    maxDay: 31,
  },
  {
    week: 44,
    month: 2,
    minDay: 1,
    maxDay: 7,
  },
  {
    week: 45,
    month: 2,
    minDay: 8,
    maxDay: 14,
  },
  {
    week: 46,
    month: 2,
    minDay: 15,
    maxDay: 21,
  },
  {
    week: 47,
    month: 2,
    minDay: 22,
    maxDay: 28,
  },
  ...(isLeapYear(new Date().getFullYear())
    ? [
      {
        week: 48,
        month: 2,
        minDay: 29,
        maxDay: 29,
      },
      {
        week: 48,
        month: 3,
        minDay: 1,
        maxDay: 6,
      },
      {
        week: 49,
        month: 3,
        minDay: 7,
        maxDay: 13,
      },
      {
        week: 50,
        month: 3,
        minDay: 14,
        maxDay: 20,
      },
      {
        week: 51,
        month: 3,
        minDay: 21,
        maxDay: 27,
      },
      {
        week: 52,
        month: 3,
        minDay: 28,
        maxDay: 31,
      },
      {
        week: 52,
        month: 4,
        minDay: 1,
        maxDay: 3,
      },
      {
        week: 53,
        month: 4,
        minDay: 4,
        maxDay: 5,
      },
    ]
    : [
      {
        week: 48,
        month: 3,
        minDay: 1,
        maxDay: 7,
      },
      {
        week: 49,
        month: 3,
        minDay: 8,
        maxDay: 14,
      },
      {
        week: 50,
        month: 3,
        minDay: 15,
        maxDay: 21,
      },
      {
        week: 51,
        month: 3,
        minDay: 22,
        maxDay: 28,
      },
      {
        week: 52,
        month: 3,
        minDay: 29,
        maxDay: 31,
      },
      {
        week: 52,
        month: 4,
        minDay: 1,
        maxDay: 4,
      },
      {
        week: 53,
        month: 4,
        minDay: 5,
        maxDay: 5,
      },
    ]),
];

export const getTaxWeekTaxYear = (date?: string) => {
  const {
    taxYear: beTaxYear,
    taxWeek: beTaxWeek,
    dateChangeToNewTaxYear,
  } = appConfigManager.getTaxCalendar() || {};

  if (!date && beTaxYear && beTaxWeek) {
    return {
      taxWeek: beTaxWeek,
      taxYear: beTaxYear,
    };
  }

  const currentDate = moment(date);
  const currentYear = Number.parseInt(currentDate.format('YYYY'));
  const currentMonth = Number.parseInt(currentDate.format('M'));
  const currentDay = Number.parseInt(currentDate.format('D'));

  const [day, month] = (
    moment(dateChangeToNewTaxYear).format('DD/MM') || '06/04'
  )
    .split('/')
    .map((e) => Number(e));

  const isChangeToNewTaxYearEarly =
    moment(date).isBefore(moment(new Date(currentYear, 4 - 1, 6))) &&
    moment(date).isAfter(moment(new Date(currentYear, month - 1, day - 1)));

  const taxWeek = isChangeToNewTaxYearEarly
    ? 1
    : taxPeriodConfig.find(
      (val) =>
        val.month === currentMonth &&
        currentDay <= val.maxDay &&
        currentDay >= val.minDay,
    )?.week || 1;

  const taxYear = moment(date).isBefore(
    moment(new Date(currentYear, month - 1, day)),
  )
    ? currentYear - 1
    : currentYear;

  return {
    taxWeek,
    taxYear,
  };
};

export const getTaxWeekTaxYearExactly = (date?: string) => {
  const { taxYearExact: taxYear, taxWeek: beTaxWeek } =
    appConfigManager.getTaxCalendar() || {};

  if (!date && taxYear && beTaxWeek) {
    return { taxWeek: beTaxWeek, taxYear };
  }

  const currentDate = moment(date);
  const currentYear = Number.parseInt(currentDate.format('YYYY'));
  const currentMonth = Number.parseInt(currentDate.format('M'));
  const currentDay = Number.parseInt(currentDate.format('D'));
  const taxWeek = taxPeriodConfig.find(
    (val) =>
      val?.month === currentMonth &&
      currentDay <= val?.maxDay &&
      currentDay >= val?.minDay,
  )?.week;

  return {
    taxWeek,
    taxYear:
      currentYear -
      (currentMonth < 4 || (currentMonth === 4 && currentDay < 6) ? 1 : 0),
  };
};

export const taxMonthConfig = (_taxYear?: number) => {
  const taxYear = _taxYear || getTaxWeekTaxYearExactly().taxYear;
  return [
    {
      taxMonth: 1,
      month: 4,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/04/${taxYear}`,
      endTaxMonth: `05/05/${taxYear}`,
    },
    {
      taxMonth: 1,
      month: 5,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/04/${taxYear}`,
      endTaxMonth: `05/05/${taxYear}`,
    },
    {
      taxMonth: 2,
      month: 5,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/05/${taxYear}`,
      endTaxMonth: `05/06/${taxYear}`,
    },
    {
      taxMonth: 2,
      month: 6,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/05/${taxYear}`,
      endTaxMonth: `05/06/${taxYear}`,
    },
    {
      taxMonth: 3,
      month: 6,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/06/${taxYear}`,
      endTaxMonth: `05/07/${taxYear}`,
    },
    {
      taxMonth: 3,
      month: 7,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/06/${taxYear}`,
      endTaxMonth: `05/07/${taxYear}`,
    },
    {
      taxMonth: 4,
      month: 7,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/07/${taxYear}`,
      endTaxMonth: `05/08/${taxYear}`,
    },
    {
      taxMonth: 4,
      month: 8,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/07/${taxYear}`,
      endTaxMonth: `05/08/${taxYear}`,
    },
    {
      taxMonth: 5,
      month: 8,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/08/${taxYear}`,
      endTaxMonth: `05/09/${taxYear}`,
    },
    {
      taxMonth: 5,
      month: 9,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/08/${taxYear}`,
      endTaxMonth: `05/09/${taxYear}`,
    },
    {
      taxMonth: 6,
      month: 9,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/09/${taxYear}`,
      endTaxMonth: `05/10/${taxYear}`,
    },
    {
      taxMonth: 6,
      month: 10,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/09/${taxYear}`,
      endTaxMonth: `05/10/${taxYear}`,
    },
    {
      taxMonth: 7,
      month: 10,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/10/${taxYear}`,
      endTaxMonth: `05/11/${taxYear}`,
    },
    {
      taxMonth: 7,
      month: 11,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/10/${taxYear}`,
      endTaxMonth: `05/11/${taxYear}`,
    },
    {
      taxMonth: 8,
      month: 11,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/11/${taxYear}`,
      endTaxMonth: `05/12/${taxYear}`,
    },
    {
      taxMonth: 8,
      month: 12,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/11/${taxYear}`,
      endTaxMonth: `05/12/${taxYear}`,
    },
    {
      taxMonth: 9,
      month: 12,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/12/${taxYear}`,
      endTaxMonth: `05/01/${taxYear + 1}`,
    },
    {
      taxMonth: 9,
      month: 1,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/12/${taxYear}`,
      endTaxMonth: `05/01/${taxYear + 1}`,
    },
    {
      taxMonth: 10,
      month: 1,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/01/${taxYear + 1}`,
      endTaxMonth: `05/02/${taxYear + 1}`,
    },
    {
      taxMonth: 10,
      month: 2,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/01/${taxYear + 1}`,
      endTaxMonth: `05/02/${taxYear + 1}`,
    },
    {
      taxMonth: 11,
      month: 2,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/02/${taxYear + 1}`,
      endTaxMonth: `05/03/${taxYear + 1}`,
    },
    {
      taxMonth: 11,
      month: 3,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/02/${taxYear + 1}`,
      endTaxMonth: `05/03/${taxYear + 1}`,
    },
    {
      taxMonth: 12,
      month: 3,
      minDay: 6,
      maxDay: 31,
      startTaxMonth: `06/03/${taxYear + 1}`,
      endTaxMonth: `05/04/${taxYear + 1}`,
    },
    {
      taxMonth: 12,
      month: 4,
      minDay: 1,
      maxDay: 5,
      startTaxMonth: `06/03/${taxYear + 1}`,
      endTaxMonth: `05/04/${taxYear + 1}`,
    },
  ];
};

export const getOptionsAllTaxWeekTaxMonth = (
  paymentFrequency: PaymentFrequencyType,
) => {
  switch (paymentFrequency) {
    case 'WEEKLY': {
      return range(1, 54, 1).map((week) => ({ // max = 53
        label: `Tax Period ${week}`,
        value: week,
      }));
    }
    case '2_WEEKLY': {
      return range(2, 56, 2).map( // max = 54
        (week) => ({
          label: `Tax Period ${week}`,
          value: week,
        }),
      );
    }
    case '4_WEEKLY': {
      return range(4, 60, 4).map( // max= 65
        (week) => ({
          label: `Tax Period ${week}`,
          value: week,
        }),
      );
    }
    case 'MONTHLY':
      return range(1, 13, 1).map((month) => ({
        label: `Tax Period ${month}`,
        value: month,
      }));
    default:
      return range(1, 54, 1).map((week) => ({
        label: `Tax Period ${week}`,
        value: week,
      }));
  }
};

export const getRangeYear = (
  isIreland: boolean = false,
  excludeYears: number[] = [],
): TaxYearOption[] => {
  const taxPeriod = getTaxWeekTaxYear();
  // Ensure current tax year is always included even if backend config is stale
  const now = moment();
  const currentYear = now.year();
  // Ireland tax year: Jan 1 – Dec 31 (always current calendar year)
  // UK tax year: Apr 6 – Apr 5 (before Apr 6 = previous year)
  const calendarTaxYear = isIreland
    ? currentYear
    : now.isBefore(moment(new Date(currentYear, 3, 6)))
      ? currentYear - 1
      : currentYear;

  let startYear = 2021;
  const out: TaxYearOption[] = [];
  const taxYear = Math.max(taxPeriod.taxYear, calendarTaxYear) + 1;
  const excludeSet = new Set(excludeYears);

  while (startYear < taxYear) {
    if (!excludeSet.has(startYear)) {
      out.push({
        label: isIreland ? `${startYear}` : `${startYear} - ${startYear + 1}`,
        value: startYear,
      });
    }
    startYear = startYear + 1;
  }

  return out;
};

export const getCurrentTaxWeek = () => {
  const { taxWeek: beTaxWeek } = appConfigManager.getTaxCalendar() || {};
  if (beTaxWeek) {
    const taxPeriodValue = taxPeriodConfig.find(
      (val) => val.week === beTaxWeek,
    );
    return taxPeriodValue;
  }

  const currentDate = moment(new Date(), 'YYYY/MM/DD');
  const currentMonth = Number.parseInt(currentDate.format('M'));
  const currentDay = Number.parseInt(currentDate.format('D'));
  const taxPeriodValue = taxPeriodConfig.find(
    (val) =>
      val.month === currentMonth &&
      currentDay <= val.maxDay &&
      currentDay >= val.minDay,
  );
  const taxPeriodDays = taxPeriodConfig.filter(
    (val) => val.week === taxPeriodValue?.week,
  );
  const taxWeekValue = taxPeriodDays?.length ? taxPeriodDays[0] : null;
  return taxWeekValue;
};

export const taxMonthDefault = taxMonthConfig();

export const getCurrentTaxMonth = () => {
  const { taxMonth: beTaxMonth, taxYear: beTaxYear } =
    appConfigManager.getTaxCalendar() || {};
  if (beTaxMonth) {
    return taxMonthConfig(beTaxYear).find((val) => val.taxMonth === beTaxMonth);
  }

  const taxMonth = null;
  const parsePaymentDate = moment().format('YYYY-MM-DD');
  for (let i = 0; i < taxMonthDefault.length; i++) {
    const taxMonthConfig = taxMonthDefault[i];
    const startDate = moment(taxMonthConfig.startTaxMonth, 'DD/MM/YYYY')
      .subtract(1, 'days')
      .format('YYYY-MM-DD');
    const endDate = moment(taxMonthConfig.endTaxMonth, 'DD/MM/YYYY')
      .add(1, 'days')
      .format('YYYY-MM-DD');
    if (moment(parsePaymentDate).isBetween(startDate, endDate)) {
      return taxMonthConfig;
    }
  }
  return taxMonth;
};

export const getTaxWeekTaxMonthOptionByFrequency = (
  frequency: string,
  fixedValue: number,
) => {
  const currentTaxWeek = getCurrentTaxWeek();
  const currentTaxMonth = getCurrentTaxMonth();
  switch (frequency) {
    case 'MONTHLY': {
      const month = fixedValue || currentTaxMonth?.taxMonth;
      return {
        label: `Tax month ${month}`,
        value: month,
      };
    }

    case '4_WEEKLY': {
      const week = fixedValue || Math.ceil((currentTaxWeek?.week || 1) / 4) * 4;
      return {
        label: `Tax week ${week}`,
        value: week,
      };
    }

    case '2_WEEKLY': {
      const week = fixedValue || Math.ceil((currentTaxWeek?.week || 1) / 2) * 2;
      return {
        label: `Tax week ${week}`,
        value: week,
      };
    }

    default: {
      const week = fixedValue || currentTaxWeek?.week || 1;
      return {
        label: `Tax week ${week}`,
        value: week,
      };
    }
  }
};

export const getCurrentTaxPeriodByFrequency = (frequency: string) => {
  const currentTaxWeek = getCurrentTaxWeek();
  const currentTaxMonth = getCurrentTaxMonth();
  switch (frequency) {
    case 'MONTHLY': {
      return currentTaxMonth?.taxMonth ?? 1;
    }

    case '4_WEEKLY': {
      return Math.ceil((currentTaxWeek?.week ?? 1) / 4) * 4;
    }

    case '2_WEEKLY': {
      return Math.ceil((currentTaxWeek?.week ?? 1) / 2) * 2;
    }

    default: {
      return currentTaxWeek?.week ?? 1;
    }
  }
};

export const getTaxYearRateThresholdOptions = () => {
  const currentTaxYear = getTaxWeekTaxYear().taxYear;
  const options = [];
  for (let year = currentTaxYear; year >= currentTaxYear - 2; year--) {
    const taxYear = {
      label: `${year < currentTaxYear ? 'Last' : 'Current'
        } Tax Year [${year} - ${year + 1}]`,
      value: `${year}-${year + 1}`,
    };
    options.push(taxYear);
  }
  return options;
};

/**
 * Get the date range (minDay, maxDay) for a given payFrequency and tax period.
 * @param payFrequency - Payment frequency type
 * @param taxPeriod - The tax period number (week or month depending on frequency)
 * @param taxYear - The tax year (e.g. 2024 for tax year 2024-2025)
 * @returns { minDay: string, maxDay: string } in DD/MM/YYYY format
 */
export const getDateRangeByPeriod = (
  payFrequency: PaymentFrequencyType,
  taxPeriod: number,
  taxYear: number,
  formatString: string = 'DD/MM/YYYY',
) => {
  if (payFrequency === 'MONTHLY') {
    const monthConfig = taxMonthConfig(taxYear);
    const entries = monthConfig.filter((c) => c.taxMonth === taxPeriod);
    if (!entries.length) return null;

    return {
      minDay: entries[0].startTaxMonth,
      maxDay: entries[0].endTaxMonth,
    };
  }

  // For WEEKLY, 2_WEEKLY, 4_WEEKLY — determine the range of weeks covered
  let weekFrom: number;
  let weekTo: number;

  switch (payFrequency) {
    case '2_WEEKLY':
      weekFrom = taxPeriod - 1;
      weekTo = taxPeriod;
      break;
    case '4_WEEKLY':
      weekFrom = taxPeriod - 3;
      weekTo = taxPeriod;
      break;
    case 'WEEKLY':
    default:
      weekFrom = taxPeriod;
      weekTo = taxPeriod;
      break;
  }

  // Collect all config entries for the week range
  const entries = taxPeriodConfig.filter(
    (c) => c.week >= weekFrom && c.week <= weekTo,
  );
  if (!entries.length) return null;

  const first = entries[0];
  const last = entries[entries.length - 1];

  // Determine the actual calendar year for start and end dates
  const getCalendarYear = (month: number) =>
    month >= 4 ? taxYear : taxYear + 1;

  const startYear = getCalendarYear(first.month);
  const endYear = getCalendarYear(last.month);

  const minDay = moment(
    new Date(startYear, first.month - 1, first.minDay),
  ).format(formatString);
  const maxDay = moment(new Date(endYear, last.month - 1, last.maxDay)).format(
    formatString,
  );

  return { minDay, maxDay };
};

export const getTaxMonthByTaxWeek = (taxWeek: number): number | undefined => {
  const weekEntry = taxPeriodConfig.find((val) => val.week === taxWeek);
  if (!weekEntry) return undefined;

  const monthConfigs = taxMonthDefault;
  const matched = monthConfigs.find(
    (mc) =>
      mc.month === weekEntry.month &&
      weekEntry.minDay >= mc.minDay &&
      weekEntry.minDay <= mc.maxDay,
  );

  return matched?.taxMonth;
};

export const formatTaxPeriodLabel = (
  payFrequency: PaymentFrequencyType | string | undefined,
  taxPeriod: number | string | undefined,
): string => {
  const periodNum =
    typeof taxPeriod === 'number' ? taxPeriod : Number(taxPeriod);
  if (!Number.isFinite(periodNum) || periodNum <= 0) return '-';

  const f = String(payFrequency ?? '').toUpperCase();

  if (f.includes('MONTH')) return `MONTH ${periodNum}`;
  if (f.includes('WEEK')) return `WEEK ${periodNum}`;
  if (f.includes('FORTNIGHT') || f.includes('2_WEEK'))
    return `WEEK ${periodNum}`;
  if (f.includes('4_WEEK')) return `WEEK ${periodNum}`;

  return String(periodNum);
};

/**
 * NX-6426: mirror of the backend's checkEmployeeJoinedAtStartOrMidYear /
 * isNIMiddleJoined rule (nxsys-backend/src/utils/checkEmployeeJoinedTaxYear.ts).
 *
 * The six "(as director)" NI opening balances only persist when the worker was
 * appointed a director part-way through the CURRENT tax year. On save the
 * backend zeroes all of them whenever this returns false, so any screen that
 * renders those inputs must gate on the same condition — otherwise the user
 * types figures, saves, and they silently vanish.
 */
export const isNIDirectorMidYear = (
  isNIDirector?: boolean | null,
  NIDirectorStartDate?: moment.MomentInput,
): boolean => {
  if (!isNIDirector || !NIDirectorStartDate) return false;

  const startDate = moment(NIDirectorStartDate).format('YYYY-MM-DD');
  const { taxYear: currentTaxYear } = getTaxWeekTaxYear();
  const { taxYear: joinedTaxYear, taxWeek: joinedTaxWeek } =
    getTaxWeekTaxYearExactly(startDate);

  // Joined in a previous tax year -> already a director when this year started.
  if (Number(joinedTaxYear) < Number(currentTaxYear)) return false;
  // Week 1 counts as the start of the year, not part-way through it.
  if (!joinedTaxWeek || joinedTaxWeek === 1) return false;

  return Number(joinedTaxYear) === Number(currentTaxYear);
};
